import { render, staticRenderFns } from "./partnerProductCard.vue?vue&type=template&id=005a2d9c&"
import script from "./partnerProductCard.vue?vue&type=script&lang=js&"
export * from "./partnerProductCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports